export type errorMessage = {
  [key: string]: string
}
const errorMessages: errorMessage = {
  // Deal Error Messages
  DEAL_LOCKED: 'You cannot make your decision as deal is currently worked by',
  DEAL_INVALID:
    'Decision cannot be submitted due to deal set-up issues. Please correct the deal set-up prior completing Decisions',
  DEAL_QUOTED:
    'Deal is quoted. Deal has been changed, workflow has been refreshed. Your approval is not required anymore.',
  DEAL_APPROVED_DISTRIBUTION:
    'Deal version status is Approved for Distribution. Please create another deal version prior to complete and submit the approval.',
  DEAL_DENIED:
    'Deal version status is Denied. Please create another deal version prior to complete and submit the approval.',
  DEAL_FREEZED: 'Deal status is currently Frozen. Your decision is not required',
  DEAL_EXPIRED: 'Deal status is currently Expired. Your decision is not required',
  DEAL_CANCELLED: 'Deal status is currently Cancelled. Your decision is not required',
  DEAL_APPOVALFLOW_REFRESHED:
    'Deal has been changed. Workflow has been refreshed. Your approval is not required anymore.',
  DECISION_NOT_REQUIRED: 'Your decision not required as you are not current approver for the deal',
  DEAL_VERSIONED_UP: 'This URL belongs to an older version. Information is not the latest.',
  // Form Error Messages
  MANDATORY_FIELDS:
    'There are mandatory questions that have not been answered. Please correct and submit again.',
  FAILED_TO_SAVE: 'Failed to save form',
  FAILED_TO_SUBMIT: 'Failed to submit form.',
  SUCESSFULLY_DRAFTED: 'Your draft has been saved successfully.',
  CANNOT_SUBMIT_WHILE_SAVING:
    'Cannot submit while decisions is being saved. Please try again when the saving is done.',
  NEWER_SUBMISSION_EXISTS:
    'Another submission exists. Please refresh the page to get the latest submitted form.',
  DATA_HAS_BEEN_CHANGED: 'Data have been changed. Please review prior taking your decision',
  // Tera Error Messages
  TERA_NEWER_SUBMISSION_EXISTS_ERROR:
    'There is newer submission exist. Please reload the app to get latest submission',

  // Session error messages
  SESSION_EXPIRED: 'Your session has timed up. Please re-login before proceeding.',
  // General Error Messages
  INTERNAL_SERVER_ERROR: 'Internal server error. Please try again later.',
  // Warning message
  SAVE_ASSIGNMENT_WARNING: 'Are you sure you want to save all the changes?',
  VPN_CONNECTION_WARNING: 'You will need VPN connection for this action',
}

export default errorMessages
